import React, { useEffect, useMemo, useState } from 'react';

import axios from 'axios';
import cookie from 'cookie_js';
import { useSnackbar } from 'notistack';
// import $ from 'jquery';
// import { isEmpty } from 'lodash';
// import * as Raven from 'raven-js';
// eslint-disable-next-line import/named
import { RouteComponentProps } from 'react-router';

import { BackLink, Typography } from '../../components/atoms';
import { Hidden, LoadingSpinner, Page } from '../../components/layouts';
import { CheckoutButton } from '../../components/molecules';
import { Basket } from '../../components/organisms';
import {
  AboutMyDataDialog,
  CampaignConsentDialog,
} from '../../components/partials';
import { MenuActionsType } from '../../types/menu.d';
import { l10nTools } from '../../utils/tools';
import { Track } from '../../weborder/analytics';
import * as Api from '../../weborder/Api';
import * as BasketControl from '../../weborder/BasketControl';
import {
  DispatchProps,
  StateProps,
} from '../../weborder/component/Restaurant/index';
import * as Intercom from '../../weborder/intercom';
// import {
//   BASKET_OFFSET,
//   MIN_BASKET_HEIGHT,
// } from '../../weborder/constants/Constants';
import * as Routes from '../../weborder/Routes';
import { storage } from '../../weborder/services/storageServices';
import { Utilities } from '../../weborder/Utilities';
import {
  LocationHeader,
  Menu,
  NotAvailableWarning,
  ProfilePanel,
} from './components';
import { menuUtils } from './utils';

interface ParentProps {
  parentComponent: JSX.Element;
}

type RouteProps = RouteComponentProps<
  {
    concessionStoreId?: number;
    id?: number;
    type?: 'collection' | 'delivery';
    vrid: number;
  },
  {}
>;

type Props = StateProps &
  DispatchProps &
  RouteProps &
  ParentProps & { params: { concessionStoreId: number } };

export function RestaurantMenu(props: Props): JSX.Element {
  const {
    AppConfig: appConfig,
    AddItemToBasket: addItemToBasket,
    AddToExpandedState: addToExpandedState,
    Basket: basket,
    ChangeLanguage: changeLanguage,
    ClearDeliveryLocations: clearDeliveryLocations,
    CollectionSummaries: collectionSummaries,
    ContactFormType: contactFormType,
    Customer: customer,
    DeliveryLocation: deliveryLocation,
    ExpandedState: expandedState,
    // ExpandedStates: expandedStates,
    getRestaurantData,
    getMenuByUrl,
    FindInitialRestaurant: findInitialRestaurant,
    flagTargetedLoadingEnabled,
    InitializeExpandedState: initializeExpandedState,
    Intercom: intercom,
    Languages: languages,
    // LoadRestaurant: loadRestaurant,
    logoutSuccessBridge,
    menu,
    MenuUrl: menuUrl,
    // Offset: offset,
    params,
    // parentComponent,
    PushLoginUrl: pushLoginUrl,
    RemoveItemFromBasket: removeItemFromBasket,
    RemoveFromExpandedState: removeFromExpandedState,
    Restaurant: restaurant,
    Restaurants: restaurants,
    SetCustomer: setCustomer,
    setUserName,
    SetCustomerEmail: setCustomerEmail,
    SetOptionsState: setOptionsState,
    ShowRestaurantList: showRestaurantList,
    SetRestaurantUrl: setRestaurantUrl,
    SetSmsEnabled: setSmsEnabled,
    translate,
  } = props;

  const isRestaurantLoadingInitiated = (status) =>
    ['pending', 'success'].includes(status);

  const { enqueueSnackbar } = useSnackbar();
  const [loadRestaurantDetailStatus, setLoadRestaurantDetailStatus] = useState(
    isRestaurantLoadingInitiated(restaurant.status) ? 'LOADING' : 'NOT_LOADED',
  );
  const [loadRestaurantListStatus, setLoadRestaurantListStatus] = useState(
    isRestaurantLoadingInitiated(restaurants.status) ? 'LOADING' : 'NOT_LOADED',
  );
  const [menuLoadState, setMenuLoadState] = useState('NOT_LOADED');
  const [showAboutMyData, setShowAboutMyData] = useState(false);

  const languageCode = l10nTools.getActiveLanguage(languages);

  const concessionStoreId = params.concessionStoreId
    ? `/${params.concessionStoreId}`
    : '';

  useEffect(() => {
    setOptionsState([], [[]], 0, []);
    setRestaurantUrl();
  }, []);

  useEffect(() => {
    if (
      restaurant.status !== 'success' &&
      loadRestaurantDetailStatus === 'NOT_LOADED' &&
      flagTargetedLoadingEnabled
    ) {
      getRestaurantData(params.vrid, params.type, params.id);
      setLoadRestaurantDetailStatus('LOADING');
    }
  }, [restaurant.status, loadRestaurantDetailStatus]);

  useEffect(() => {
    if (restaurant.status === 'success') {
      setLoadRestaurantDetailStatus('LOADED');
    }
  }, [restaurant.status]);

  useEffect(() => {
    if (
      flagTargetedLoadingEnabled &&
      menuLoadState === 'NOT_LOADED' &&
      !menu &&
      restaurant.status === 'success'
    ) {
      getMenuByUrl(restaurant.data.MenuUrl);
      setMenuLoadState('LOADING');
    }
  }, [menu, menuLoadState, restaurant]);

  useEffect(() => {
    if (
      restaurants.status !== 'success' &&
      loadRestaurantListStatus === 'NOT_LOADED' &&
      !flagTargetedLoadingEnabled
    ) {
      findInitialRestaurant();
      setLoadRestaurantListStatus('LOADING');
    }
  }, [restaurants.status, loadRestaurantListStatus]);

  useEffect(() => {
    if (restaurants.status === 'success') {
      setLoadRestaurantListStatus('LOADED');
    }
  }, [restaurants.status]);

  useEffect(() => {
    if (
      !flagTargetedLoadingEnabled &&
      menuLoadState === 'NOT_LOADED' &&
      !menu &&
      menuUrl
    ) {
      getMenuByUrl(menuUrl);
      setMenuLoadState('LOADING');
    }
  }, [menu, menuLoadState, menuUrl]);

  useEffect(() => {
    if (menu) {
      setMenuLoadState('LOADED');
    }
  }, [menu]);

  const handleOnAddItem = (payload: BasketControl.Item) => {
    addItemToBasket(payload);
  };
  const handleOnRemoveItem = (payload: {
    menuId: number;
    index: number;
    indexName?: string;
  }) => {
    enqueueSnackbar(
      translate('An_item_was_removed_from_your_basket') as string,
    );
    removeItemFromBasket(payload);

    // TODO inspect what is this??? why would u ever need to 'click' on div
    const node = document.getElementById('flipdish-div');
    if (node) {
      Utilities.fireEvent(node, 'click');
    }
  };
  const handleOnCheckout = () => {
    // switch (restaurant.status) {
    //   case 'pending':
    //   case 'none':
    //     Raven.captureMessage(
    //       'Cannot view the basket when the restaurant is not loaded',
    //     );
    //     return;
    //   default:
    //     break;
    // }

    // let initialLang = 'en';

    // for (const language of languages) {
    //   if (language.active) {
    //     initialLang = language.code;
    //     break;
    //   }
    // }

    // // Don't start the checkout process unless the user has enough
    // // value in the basket.
    // const currentBasketTotal = BasketControl.Total(basket.items);
    // if (currentBasketTotal < restaurant.data.MinimumOrder) {
    //   // TODO: convert to Alert/Snackbox
    //   alert(
    //     translate('Minimum_order', {
    //       restaurantName: restaurant.data.RestaurantName,
    //       amount: BasketControl.ToCurrency(
    //         restaurant.data.MinimumOrder,
    //         restaurant.data.Currency,
    //         initialLang,
    //       ),
    //     }),
    //   );
    //   return;
    // }

    const alcoholInBasket = basket.items.find((item) => item.Item.Alcohol);
    const nextPage = alcoholInBasket ? 'over18' : 'checkout';
    let nextUrl = `/${nextPage}/${params.vrid}/${params.type}/${params.id}${concessionStoreId}`;

    if (restaurant.status === 'success' && customer.status === 'success') {
      Track('Orders', 'Checkout', {
        event_label: restaurant.data.RestaurantName,
      });

      const isAlcoholAgeConfirmRequired = !customer.data
        .RequireAgeConfirmationForAlcoholOrdersData.DisplayConfirmationPrompt;

      if (!isAlcoholAgeConfirmRequired) {
        nextUrl = `/checkout/${params.vrid}/${params.type}/${params.id}${concessionStoreId}`;
      }

      Utilities.navigateTo(nextUrl);
    } else {
      loginAndNavigateTo(true);
    }
  };

  const orderBasket = useMemo(() => {
    if (
      basket.items.length === 0 ||
      appConfig.status !== 'success' ||
      restaurant.status !== 'success' ||
      menu === null
    ) {
      return null;
    }

    const isDeliveryOrder =
      restaurant.data.DeliveryType === Api.DeliveryType.Delivery;
    const isOutsideDeliveryZone = !Routes.OutsideDeliveryZone(restaurant);
    const { buttonLabel, isCheckoutEnabled } = menuUtils.getButtonState(
      restaurant.data.AcceptPreOrders,
      isDeliveryOrder,
      isOutsideDeliveryZone,
      restaurant.data.IsOpen,
      translate,
    );

    const basketActions = {
      onAddItem: addItemToBasket,
      onCheckout: handleOnCheckout,
      onRemoveItem: removeItemFromBasket,
    };

    return (
      <Basket
        actions={basketActions}
        basketItems={basket.items}
        buttonLabel={buttonLabel}
        currency={restaurant.data.Currency}
        languageCode={languageCode}
        isCheckoutEnabled={isCheckoutEnabled}
        menuId={menu.MenuId}
        minOrder={restaurant.data.MinimumOrder}
        translate={translate}
        vrId={params.vrid}
      />
    );
  }, [appConfig.status, basket.items, menu, restaurant.status]);

  const checkoutButton = useMemo(() => {
    if (
      basket.items.length === 0 ||
      appConfig.status !== 'success' ||
      restaurant.status !== 'success' ||
      menu === null
    ) {
      return null;
    }

    const isDeliveryOrder =
      restaurant.data.DeliveryType === Api.DeliveryType.Delivery;
    const isOutsideDeliveryZone = !Routes.OutsideDeliveryZone(restaurant);
    const { buttonLabel, isCheckoutEnabled } = menuUtils.getButtonState(
      restaurant.data.AcceptPreOrders,
      isDeliveryOrder,
      isOutsideDeliveryZone,
      restaurant.data.IsOpen,
      translate,
    );

    const basketActions = {
      onAddItem: addItemToBasket,
      onCheckout: handleOnCheckout,
      onRemoveItem: removeItemFromBasket,
    };

    return (
      <CheckoutButton
        actions={basketActions}
        basketItems={basket.items}
        buttonLabel={buttonLabel}
        currency={restaurant.data.Currency}
        languageCode={languageCode}
        isCheckoutEnabled={isCheckoutEnabled}
        minOrder={restaurant.data.MinimumOrder}
        translate={translate}
        vrId={params.vrid}
      />
    );
  }, [appConfig.status, basket.items, menu, restaurant.status]);

  // // public UNSAFE_componentWillReceiveProps(newProps: Props) {
  // //   const { flagTargetedLoadingEnabled, flagServiceStatus } = newProps;

  // // if (this.props.menu) {
  // //   this.setState({ menuLoadState: 'LOADED' });
  // // }

  // // TODO: restore this functionality
  // // this.resizeBasket();
  // // }

  // // TODO: restore this functionality
  // // public componentDidUpdate() {
  // //   this.resizeBasket();
  // // }

  // // TODO: restore this functionality
  // // public componentWillUnmount() {
  // //   const top = window.pageYOffset;

  // //   if (top) {
  // //     this.props.SetMenuScroll(top);
  // //   }

  // //   window.removeEventListener('scroll', this.resizeBasket);
  // // }

  // // TODO: restore this functionality
  // // private resizeBasket = () => {
  // //   const basket = document.getElementsByClassName(
  // //     'basket-item-list',
  // //   )[0] as HTMLElement;

  // //   const basketHolder = document.getElementsByClassName(
  // //     'menu__basket',
  // //   )[0] as HTMLElement;

  // //   if (basket && basketHolder) {
  // //     //Offset to calculate basket height
  // //     let offset = 0;

  // //     //Offset for scroll height
  // //     const scrollOffset = $(basketHolder).offset().top;

  // //     if (window.scrollY <= scrollOffset) {
  // //       //If basket is not in "fixed-top" mode offset accounts for the amount the page is scrolled down and the sum of the heights of the basket header and checkout button
  // //       offset = BASKET_OFFSET + (scrollOffset - window.scrollY);
  // //     } else {
  // //       //If basket is in "fixed-top" mode offset is the top offset to account for headers (data-offset) and the sum of the heights of the basket header and checkout button
  // //       offset = BASKET_OFFSET + this.props.Offset;
  // //     }

  // //     if (document.documentElement.clientHeight - offset <= MIN_BASKET_HEIGHT) {
  // //       basket.style.maxHeight = `${MIN_BASKET_HEIGHT}px`;
  // //     } else {
  // //       basket.style.maxHeight = `calc(100vh - ${offset}px)`;
  // //     }
  // //   }
  // // };

  const loginAndNavigateTo = (checkout: boolean) => {
    let loginUrl = window.location.hash.substr(1);
    if (checkout) {
      loginUrl = loginUrl.replace('restaurant', 'checkout');
    }

    pushLoginUrl(loginUrl);

    const redirectUrl =
      params.type === 'delivery' ? `/phone/${params.id}` : 'phone';
    Utilities.navigateTo(redirectUrl);
  };

  const getBacklinkUrl = () => {
    if (appConfig.status !== 'success') {
      return '/where';
    }

    const {
      DisplayPickupRestaurantListScreen: displayPickupRestaurantListScreen,
    } = appConfig.data;

    const concessionStoreIdUrl = params.concessionStoreId
      ? `/concession/${params.vrid}/${params.id}`
      : `/${params.type}`;

    const backLinkUrl =
      !displayPickupRestaurantListScreen && params.type === 'collection'
        ? '/where'
        : concessionStoreIdUrl;

    return backLinkUrl;
  };
  const getCollectionLink = (): string => {
    if (appConfig.status !== 'success') {
      return '/collection';
    }

    if (appConfig.data.DisplayPickupRestaurantListScreen) {
      return '/collection';
    }

    if (collectionSummaries.status != 'success') {
      return '/collection';
    }

    const [skip] = collectionSummaries.data.filter(
      (c) => c.SkipToThisPhysicalRestaurant,
    );

    if (!skip) {
      return '/collection';
    }

    return `/restaurant/${skip.VirtualRestaurantId}/collection/${skip.PhysicalRestaurantId}`;
  };
  const getRestaurantName = (configData): string => {
    if (restaurant.status !== 'success') {
      const { Category: category } = configData;

      const categoryName = menuUtils.getCategoryTranslationKey(category);
      const loadingMessage = translate('Loading_category_name', {
        categoryName: translate(categoryName) as string,
      });

      return `${loadingMessage}...`;
    }

    const stores = (menu && (menu as any).ConcessionStores) || [];

    if (params.concessionStoreId && stores && stores.length > 0) {
      const concessionStoreId = parseInt(`${params.concessionStoreId}`);
      const index = stores.findIndex(
        (store) => store.ConcessionStoreId === concessionStoreId,
      );

      if (index !== -1 && stores[index]) {
        return stores[index].Name + ', ' + restaurant.data.RestaurantName;
      }
    }

    return restaurant.data.RestaurantName;
  };

  const clearCustomerSession = () => {
    logoutSuccessBridge();

    setCustomer({ status: 'none' });

    cookie.remove('flipdish-token');
    storage.removeItem('flipdish-delivery-locations');
    storage.removeItem('flipdish-location');
    storage.removeItem('flipdish-device-id');

    let link = '/where';

    if (appConfig.status === 'success' && !appConfig.data.PickupEnabled) {
      link = '/delivery';
    } else if (
      appConfig.status === 'success' &&
      !appConfig.data.DeliveryEnabled
    ) {
      link = getCollectionLink();
    } else if (!showRestaurantList) {
      link = `/restaurant/${params.vrid}`;
    }

    Utilities.navigateTo(link);
  };

  const handlePromotionsSetting = (state: boolean) => {
    const payload = {
      enabled: state,
    };

    axios.put('/Account/SmsPromotionsEnabledFlag', payload).then((r) => {
      setSmsEnabled(r.data.Data.enabled);
    });
  };
  const handleLogout = () => {
    setCustomer({ status: 'pending' });

    axios
      .post('/Account/LogOff')
      .then(clearCustomerSession, clearCustomerSession);

    clearDeliveryLocations();
  };
  const handleClickItem = (payload: { menuId: number; item: Api.MenuItem }) => {
    if (restaurant.status !== 'success') {
      console.error('Cannot click - restaurant is', restaurant.status, props);
      return;
    }

    if (!restaurant.data.IsOpen && !restaurant.data.AcceptPreOrders) {
      const openAt = Utilities.getOpeningTime(restaurant.data);
      alert(
        translate('Sorry_{restaurantName}_is_closed_It_will_open_at_{openAt}', {
          restaurantName: restaurant.data.RestaurantName,
          openAt,
        }),
      );
      return;
    }

    const { menuId, item } = payload;
    if (item.MenuItemOptionSets.length == 0) {
      handleOnAddItem({ Item: item, Options: [] });

      Track('Restaurants', 'Add Item To Basket Via Menu Directly', {
        event_label: item.Name,
        virtualRestaurantId: params.vrid,
        name: item.Name,
        itemType: item.MenuItemOptionSets.length == 0 ? 'simple' : 'complex',
        menuId,
      });
      return;
    }

    const { id, type, vrid } = params;
    const configureUrl = `/restaurant/${vrid}/${type}/${id}${concessionStoreId}/configure/${item.MenuItemId}/0`;
    Utilities.navigateTo(configureUrl);
  };
  const handleContactUs = () => {
    Track('Profile', 'Contact Us');
    Intercom.ShowMessages(intercom);
  };
  const toggleAboutMyDataDialog = () => setShowAboutMyData(!showAboutMyData);

  // // const isMenuFullyLoaded =
  // //   !!menu &&
  // //   hasExpandedStates &&
  // //   appConfig.status === 'success' &&
  // //   restaurant.status === 'success';
  // // ((menu && !isEmpty(expandedStates)) || !isOutsideDeliveryZone);

  if (appConfig.status !== 'success' || restaurant.status !== 'success') {
    return <LoadingSpinner />;
  }

  const backlinkUrl = getBacklinkUrl();
  const currency = restaurant.data.Currency
    ? restaurant.data.Currency
    : Api.Currency.EUR;
  const isDeliveryOrder =
    restaurant.data.DeliveryType === Api.DeliveryType.Delivery;
  const isOutsideDeliveryZone = !Routes.OutsideDeliveryZone(restaurant);

  const menuActions = {
    onAddExpanded: addToExpandedState,
    onAddItem: handleOnAddItem,
    initExpanded: initializeExpandedState,
    onItemClick: handleClickItem,
    onRemoveExpanded: removeFromExpandedState,
    onRemoveItem: handleOnRemoveItem,
  } as MenuActionsType;

  const profileActions = {
    onAboutMyData: toggleAboutMyDataDialog,
    onChangeEmail: setCustomerEmail,
    onChangeLanguage: changeLanguage,
    onChangeName: setUserName,
    onChangePromotions: handlePromotionsSetting,
    onContactUs: handleContactUs,
    onLogin: () => loginAndNavigateTo(false),
    onLogOut: handleLogout,
  };

  return (
    <>
      <Page pageName="restaurant-menu">
        <header>
          <BackLink
            label={translate('Back')}
            linkPath={backlinkUrl}
            testId="restaurant-back"
          />

          <Typography variant="h1">
            {getRestaurantName(appConfig.data)}
          </Typography>
        </header>

        <article>
          <LocationHeader
            configData={appConfig.data}
            currency={currency}
            deliveryLocation={deliveryLocation}
            languageCode={languageCode}
            restaurantData={restaurant.data}
            translate={translate}
          />

          <NotAvailableWarning
            isDeliveryOrder={isDeliveryOrder}
            isOutsideDeliveryZone={isOutsideDeliveryZone}
            restaurantData={restaurant.data}
            translate={translate}
          />

          <Menu
            actions={menuActions}
            basket={basket}
            concessionStoreId={params.concessionStoreId}
            currency={currency}
            languageCode={languageCode}
            expandedState={expandedState}
            isOutsideDeliveryZone={isOutsideDeliveryZone}
            menuData={menu}
            restaurantData={restaurant.data}
            translate={translate}
            vrId={params.vrid}
          />
        </article>

        <section>
          <ProfilePanel
            actions={profileActions}
            configData={appConfig.data}
            contactFormType={contactFormType}
            customer={customer}
            languageCode={languageCode}
            params={params as any}
            translate={translate}
          />

          <Hidden mdDown>{orderBasket}</Hidden>
        </section>
      </Page>

      <Hidden lgUp>{checkoutButton}</Hidden>

      {customer.status === 'success' && !!customer.data.EmailAddress && (
        <CampaignConsentDialog customer={customer} />
      )}

      {showAboutMyData && (
        <AboutMyDataDialog
          handleOnClick={toggleAboutMyDataDialog}
          showDialog={showAboutMyData}
          translate={translate}
        />
      )}
    </>
  );
}
